import React from 'react'
import { css } from '@emotion/core'
import { Expander, ExpanderHeader, ExpanderContent } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import PersonChangeRow from './PersonChangeRow'
import { DmcText } from '../../common/DmcText'

const labelCss = css`
  button {
    background: var(--gray02a);
  }
`
const subChangesCss = css`
  table {
    padding-inline-start: 4em;
    padding-inline-end: 0;
    background: var(--gray02a);
  }
`

const borderCss = css`
  td {
    border-bottom: 1px solid var(--gray10);
  }
`

const SubLevelChanges = ({
  openGroups,
  setOpenGroups,
  topChange,
  group,
  changes,
  personChangesState,
  personChangesDispatch,
}) => {
  const { t } = useTranslation()

  return (
    <tr css={borderCss}>
      <td colSpan={3} css={[labelCss, subChangesCss]}>
        <Expander
          open={openGroups[topChange.metadata.changeId]}
          setOpen={() => {
            setOpenGroups((prev) => ({ ...prev, [topChange.metadata.changeId]: !prev[topChange.metadata.changeId] }))
          }}
        >
          <ExpanderHeader data-testid={`toggleSubChanges-${topChange.metadata.changeId}`}>
            <DmcText text={t('person.changes.subLevelChanges', 'Sub-level Changes')} bold />
          </ExpanderHeader>
          <ExpanderContent>
            <span
              css={css`
                thead {
                  display: none;
                }
              `}
            >
              <DmcResponsiveTable
                id={`subChangesTable-${topChange.metadata.changeId}`}
                totalColumnCount={3}
                atSizeColumns={{
                  default: {
                    labels: ['', '', ''],
                  },
                }}
              >
                {changes.map((personChange) => (
                  <PersonChangeRow
                    key={personChange.metadata.changeId}
                    personChange={personChange}
                    personChangeGroup={group}
                    personChangesState={personChangesState}
                    personChangesDispatch={personChangesDispatch}
                  />
                ))}
              </DmcResponsiveTable>
            </span>
          </ExpanderContent>
        </Expander>
      </td>
    </tr>
  )
}

export default SubLevelChanges
